// Koordinaten (Breite, Länge) für die Referenzkarte. Neuer Ort in referenzen.js → hier eintragen.
// Referenzen ohne Ort (oder ohne Erlaubnis, den Ort zu nennen) erscheinen auf der Karte als gestrichelte Nadel
// an einer beispielhaften Position (BEISPIEL_PLAETZE in ReferenzKarte.js), mit Hinweis unter der Karte.
import betrieb from "./betrieb";

export const BETRIEB = { name: betrieb.ort, lat: betrieb.geo.lat, lon: betrieb.geo.lon };

export const ORTE = {
  Schrevenborn: [54.37, 10.21],
  Kiel: [54.32, 10.13],
  "Lübeck": [53.87, 10.69],
  Flensburg: [54.78, 9.44],
  "Neumünster": [54.07, 9.98],
  "Eckernförde": [54.47, 9.84],
  Rendsburg: [54.3, 9.66],
  Schleswig: [54.52, 9.56],
  "Plön": [54.16, 10.42],
  Preetz: [54.24, 10.28],
  "Lütjenburg": [54.29, 10.59],
  "Schönberg": [54.39, 10.37],
  "Bad Segeberg": [53.94, 10.31],
  "Oldenburg in Holstein": [54.29, 10.88],
  Itzehoe: [53.92, 9.52],
  Probsteierhagen: [betrieb.geo.lat, betrieb.geo.lon],
  Hohwacht: [54.32, 10.67],
  Seth: [53.87, 10.18],
};

/**
 * Ergänzt jede Referenz mit bekanntem Ort um ihre Koordinaten (lat/lon).
 * Referenzen ohne (bekannten) Ort bleiben ohne Koordinaten; ReferenzKarte zeichnet sie als gestrichelte Nadel an einem beispielhaften Platz.
 */
export function standorte(referenzen) {
  return referenzen.map((r) => (r.ort && ORTE[r.ort] ? { ...r, lat: ORTE[r.ort][0], lon: ORTE[r.ort][1] } : r));
}
